export enum EnumAppointmentStatus{
    Ongoing="Ongoing",
    Upcoming="Upcoming",
    Complete="Complete",
    NotAccepted="NotAccepted",    
}